import { useEffect, useState } from "react";
// import { useHistory, useLocation } from "react-router-dom";
import { Status, StatusName, StatusType } from "config/config";
import { getOrderById, getOrderDetailsById } from "service/request";

const orderDataInitialState = {
  number: '',
  estimatedTime: '',
  timeZoneId: '',
  companyName:'',
  rejectedReason: '',
  address: '',
  distance: {
    unit: 'ml',
    value: 0,
  },
  duration: {
    unit: 'minute',
    value: 0,
  },
  isScheduled: false,
  provider: '',
};
const getStatusValue = (key) => Status[key];
const getStatusName = (key) => StatusName[key];

const useOrderTrackingDetails = (
  queryOrderId,
  canceledByDelivery,
  setLoading,
  setCanceledByProvider,
  canceledByProvider,
  queryBusinessId,
  queryBusinessUuid
) => {
  // const location = useLocation();
  // const history = useHistory()
  const [orderInfo, setOrderInfo] = useState(orderDataInitialState);
  const [activeOrderStep, setActiveOrderStep] = useState(Status.unconfirmed);
  const [activeOrderStatus, setActiveOrderStatus] = useState(StatusName.unconfirmed);

  // const removeQueryParam = (key) => {
  //   const searchParams = new URLSearchParams(location.search);
  //   searchParams.delete(key);

  //   history.replace({
  //     pathname: location.pathname,
  //     search: `?${searchParams.toString()}`,
  //   });
  // };

  useEffect(() => {
    if (!queryOrderId || !queryBusinessId || !queryBusinessUuid) return;

    let intervalId;

    const fetchOrderData = async () => {
      try {
        const response = await getOrderById(queryOrderId, queryBusinessId, queryBusinessUuid);
        const trackingOrderData = response?.data?.data;
        const orderData = {
          number: trackingOrderData?.number,
          companyName: trackingOrderData?.business[0]?.companyName ||
            trackingOrderData?.business[0]?.title || '',
          address: trackingOrderData?.deliveryInfo?.addressInfo?.address1 ||
            trackingOrderData?.delivery?.deliveryAddress?.address1 || '',
          distance: trackingOrderData?.deliveryInfo?.quote?.distance,
          duration: trackingOrderData?.deliveryInfo?.quote?.duration,
          estimatedTime: trackingOrderData?.dropOffTimeRange?.endTime || '',
          isScheduled: trackingOrderData?.isScheduled || false,
          rejectedReason: trackingOrderData?.status?.cancellationReason || '',
          timeZoneId: trackingOrderData?.business[0]?.timezone?.timeZoneId || 'America/Los_Angeles',
          provider: trackingOrderData?.provider,
        }
        setOrderInfo(orderData);
        const currentStep = getStatusValue(trackingOrderData?.status?.status);
        const currentStatusName = getStatusName(trackingOrderData?.status?.status);
        currentStep && setActiveOrderStep(currentStep);
        currentStatusName && setActiveOrderStatus(currentStatusName);
        // if (currentStatusName === StatusName.canceled || currentStatusName === StatusName.rejected) {
        //   clearInterval(intervalId);
        // }
        if (canceledByDelivery) {
          // clearInterval(intervalId);
          setActiveOrderStatus(StatusName.canceled);
          setActiveOrderStep(Status.canceled);
        }
        if (canceledByProvider) {
          // setActiveOrderStep(Status.canceled_from_provider);
          // setActiveOrderStatus(StatusName.canceled_from_provider);
        }
        setTimeout(() => {
          setLoading(false);
        },1000)
      } catch (error) {
        setTimeout(() => {
          setLoading(false);
        },1000)
        console.error('Error fetching tracking URL:', error);
      }
    };
    fetchOrderData().then(() => {});
    intervalId = setInterval(fetchOrderData, process.env.REACT_APP_TRACKING_INTERVAL);

    // if (canceledByDelivery) {
    //   clearInterval(intervalId);
    //   setActiveOrderStatus(StatusName.canceled);
    //   setActiveOrderStep(Status.canceled);
    // }
    // if (canceledByProvider) {
    //   setActiveOrderStep(Status.canceled_from_provider);
    //   setActiveOrderStatus(StatusName.canceled_from_provider);
    // }
    return () => clearInterval(intervalId);
  },[queryOrderId, canceledByDelivery, canceledByProvider, queryBusinessId, queryBusinessUuid])

  useEffect(() => {
    if (!queryOrderId || !queryBusinessId) return;


    if (activeOrderStep >= Status.completed) {
      let intervalId;

      const fetchDeliveryStatus = async () => {
        try {
          const response = await getOrderDetailsById(queryOrderId, queryBusinessId);
          const trackingStatus = response?.data?.data;
          console.log(trackingStatus?.status, 'trackingStatus?.status');
          if (trackingStatus?.status?.toLowerCase() === StatusName.canceled.toLowerCase()) {
            // removeQueryParam('tr');
            setCanceledByProvider(true);
            if (trackingStatus.status  === StatusType.CANCELED_FROM_PROVIDER) {
              setCanceledByProvider(true);
              // setActiveOrderStep(Status.canceled_from_provider);
              // setActiveOrderStatus(StatusName.canceled_from_provider);
            }
            // if (trackingStatus?.status === StatusName.canceled) {
            //   clearInterval(intervalId);
            // }
            return;
          }
          if (trackingStatus?.status === StatusType.COMPLETED_COMPLETE){
            setActiveOrderStep(Status.completed_complete);
            setActiveOrderStatus(StatusName.completed_complete);
            return;
          }
          if (trackingStatus?.status === StatusType.COMPLETED){
            setActiveOrderStep(Status.complete);
            setActiveOrderStatus(StatusName.complete);
            // clearInterval(intervalId);
          }
        } catch (error) {
          console.error('Error fetching tracking URL:', error);
        }
      };
      fetchDeliveryStatus().then(() => {});
      intervalId = setInterval(fetchDeliveryStatus, process.env.REACT_APP_TRACKING_INTERVAL);

      return () => clearInterval(intervalId);
    }
  }, [activeOrderStep, queryOrderId, queryBusinessId]);

  return {
    orderInfo,
    activeOrderStep,
    activeOrderStatus,
  }
}

export default useOrderTrackingDetails;